import classnames from "classnames";
import {IconType} from "react-icons";
import {TbCircleCheckFilled, TbCircleNumber2Filled, TbCircleNumber3Filled} from "react-icons/tb";

import {Icon} from "@/components/icon/Icon.tsx";

import styles from "./StepsBar.module.scss";

interface StepsBarProps {
  className?: string;
  steps: {
    name: string;
    completed: boolean;
  }[];
}

// better to create a CSS styled border around number, however for simplicity we will use icons
const numbers: Record<number, IconType> = {
  1: TbCircleNumber2Filled,
  2: TbCircleNumber3Filled,
};

export const StepsBar = ({className, steps}: StepsBarProps) => (
  <div className={classnames(styles.stepsBar, className)}>
    {steps.map((step, index) => (
      <div key={index} className={styles.step}>
        <Icon className={styles.icon} icon={step.completed ? TbCircleCheckFilled : numbers[index]} />
        <span className="text-uppercase">{step.name}</span>
      </div>
    ))}
  </div>
);
